import {ContentLoader} from "../ContentLoader";

const CompanyFeaturedLoader = (keyIndex) => {
	return (<ContentLoader width='100%' height={190}/>)
};

export default CompanyFeaturedLoader
